/**
 * Build-time media configuration. Both keys are declared in `src/vite-env.d.ts`.
 *
 * The mock path stays alive behind `VITE_USE_MOCK` so the meeting UI can still
 * be demoed with no SFU reachable; the REAL provider is the default.
 */
function trimmed(value: string | undefined): string | null {
  if (value === undefined) return null;
  const text = value.trim();
  return text.length > 0 ? text : null;
}

/**
 * Overrides the SFU URL minted by the API — needed whenever the browser reaches
 * the SFU through a different host than apps/api does. Unset in production.
 */
export const LIVEKIT_WS_URL: string | null = trimmed(import.meta.env.VITE_LIVEKIT_WS_URL);

/** `true` keeps the media plane on the simulated provider, for offline demos. */
export const USE_MOCK: boolean = trimmed(import.meta.env.VITE_USE_MOCK) === 'true';
